import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import ReactMarkdown from 'react-markdown'

import { SavingAccount } from '../../../types/savingAccount'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: '950px',
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  mainSection: {
    maxWidth: '90%',
    margin: '50px auto',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 50px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      margin: '10px auto',
      padding: '0 25px',
    },
  },
  title: {
    fontSize: '2em',
    marginBottom: '15px',
    [theme.breakpoints.down('md')]: {
      fontSize: '28px',
    },
  },
  description: {
    background: '#fafafa',
    marginBottom: '20px',
    [theme.breakpoints.down('md')]: {
      marginBottom: '20px',
    },
  },
  buttonContainer: {
    marginTop: '25px',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  button: {
    height: '64px',
    width: '215px',
    fontSize: '18px',
    [theme.breakpoints.down('md')]: {
      margin: '30px auto',
    },
  },
  iconLike: {
    marginRight: '20px',
    height: '25px',
    width: '30px',
  },
  like: {
    marginTop: '20px',
    [theme.breakpoints.down('md')]: {
      marginTop: '10px',
    },
  },
  markdown: {
    fontSize: '18px',
    color: '#555555',
    lineHeight: '1.8em',
    overflowWrap: 'break-word',
    '& img': {
      maxWidth: '100%',
    },
    '& a': {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
  },
  likeTitle: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 'fit-content',
    '& h5': {
      color: theme.palette.primary.main,
      position: 'relative',
    },
  },
  titleBackground: {
    position: 'absolute',
    top: '15px',
    left: '10px',
    width: '90%',
    backgroundColor: theme.palette.secondary.main,
    height: '18px',
    zIndex: -1,
  },
  review: {
    marginTop: '1rem',
    padding: '20px',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
    },
  },
  reviewTitle: {
    position: 'relative',
    width: 'fit-content',
    '& h5': {
      position: 'relative',
    },
  },
  reviewMarkdown: {
    color: '#585858',
  },
  purpleSquare2: {
    position: 'absolute',
    zIndex: -1,
    top: '-20px',
    left: '0',
    border: `2px solid ${theme.palette.primary.main}`,
    width: '120%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  hideMobile: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  showMobile: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  promotionSection: {
    position: 'relative',
    width: 'fit-content',
    marginBottom: '20px',
  },
  promotion: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    position: 'relative',
  },
  promotionBackground: {
    position: 'absolute',
    top: '10px',
    left: '-5px',
    width: '105%',
    backgroundColor: theme.palette.secondary.main,
    height: '18px',
  },
}))

function SavingsAccountReview(props: SavingAccount): JSX.Element {
  const classes = useStyles({})

  return (
    <div className={classes.container}>
      <div className={classes.mainSection}>
        <Typography variant="h1" className={classes.title}>
          {props.name}
        </Typography>
        <Typography variant="body1" className={classes.description}>
          {props.short_description}
        </Typography>
        <div>
          {props.promotion && (
            <div className={classes.promotionSection}>
              <div className={classes.promotionBackground} />
              <Typography variant="subtitle2" className={classes.promotion}>
                {props.promotion}
              </Typography>
            </div>
          )}
          {props.provider && (
            <div className={classes.review}>
              <div className={classes.reviewTitle}>
                <Typography variant="h5">Full {props.name} Review</Typography>
              </div>
              <ReactMarkdown className={`${classes.markdown} ${classes.reviewMarkdown}`}>
                {props.provider}
              </ReactMarkdown>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SavingsAccountReview
